import { Cancel } from './Cancel';
export class CancelToken {
    static source() {
        let cancel;
        const token = new CancelToken((_cancel) => {
            cancel = _cancel;
        });
        return {
            token,
            cancel: cancel,
        };
    }
    constructor(executor) {
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolvePromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.promise = new Promise((resolve) => {
            this.resolvePromise = resolve;
        });
        executor((message) => {
            if (this._reason) {
                // Cancellation has already been requested
                return;
            }
            this._reason = new Cancel(message);
            this.resolvePromise(this._reason);
        });
    }
    get reason() {
        return this._reason;
    }
    throwIfRequested() {
        if (this.reason) {
            throw this.reason;
        }
    }
}
//# sourceMappingURL=CancelToken.js.map